import { render, staticRenderFns } from "./UploadInitiativeModal.vue?vue&type=template&id=6c8215a2&"
import script from "./UploadInitiativeModal.vue?vue&type=script&lang=js&"
export * from "./UploadInitiativeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports